import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import TableContainer from '@mui/material/TableContainer';
import { Typography } from '@components/Typography';
import { Table } from '@components/Table';
import { useTranslation, useTableSort } from '@hooks';
import { formatNumber } from '@helpers/formatNumbers';

const SORT_COLUMNS = { keyword: 'keyword', views: 'views' };

const Container = styled(Paper)({
    padding: '24px',
    width: '100%',
    borderRadius: 8,
    '@media print': {
        breakInside: 'avoid',
    },
});

const getTableHeader = t => {
    return [
        {
            key: 0,
            sortKey: 'keyword',
            component: (
                <Typography variant="subtitle2" align="left">
                    {t('AnalyticsKeywords.keyword')}
                </Typography>
            ),
        },
        {
            key: 1,
            sortKey: 'views',
            align: 'right',
            component: (
                <Typography variant="subtitle2" align="right">
                    {t('AnalyticsPresence.searchAppearances')}
                </Typography>
            ),
        },
    ];
};

const getTableBody = data => {
    return data.map(({ keyword, views }) => [
        {
            component: (
                <Typography variant="body2" align="left">
                    {keyword}
                </Typography>
            ),
        },
        {
            component: (
                <Typography variant="body2" align="right">
                    {formatNumber(views)}
                </Typography>
            ),
        },
    ]);
};

const SearchKeywordsTable = ({ isLoading, data }) => {
    const { t } = useTranslation();
    const { sort, onSortChange, sortedData } = useTableSort(data, { columns: SORT_COLUMNS });

    return (
        <Container elevation={1}>
            <Typography variant="title1" sx={{ color: 'var(--text-primary)', display: 'block', marginBottom: '16px' }}>
                {t('AnalyticsPresence.searchKeywords')}
            </Typography>
            <TableContainer>
                <Table
                    data={sortedData}
                    columnNames={getTableHeader(t)}
                    rows={getTableBody(sortedData)}
                    isDataLoading={isLoading}
                    sort={sort}
                    onSortChange={onSortChange}
                />
            </TableContainer>
        </Container>
    );
};

export default SearchKeywordsTable;
